export default __webpack_public_path__ + "media/images/brands/demo/logos/logo-dark-164x76-1f770d174f28030395616c3586130b8f.png";